/* eslint-disable @typescript-eslint/no-explicit-any */
import {FC, useEffect, useState} from 'react';
import {useGraphqlQuery} from 'hooks/useGraphqlQuery';
import {DocumentNode} from '@apollo/client';
import LoaderWithBackdrop from 'components/LoaderWithBackdrop';

export type GraphqlQuery = DocumentNode;

type ParamValidatorFn = (old: any, current: any) => boolean;

interface GqlQueryControllerChildProps {
  data: any;
  isLoading?: boolean;
  fetch: () => Promise<void>;
  setQueryVars: Function;
}

export interface GqlQueryControllerProps {
  initialState: any;
  QUERY: GraphqlQuery;
  variables?: any;
  rootField: string;
  onSuccess?: Function;
  paramValidator?: ParamValidatorFn;
  children: (
    props: GqlQueryControllerChildProps
  ) => JSX.Element | JSX.Element[];
}

const GqlQueryController: FC<GqlQueryControllerProps> = ({
  initialState,
  QUERY,
  variables,
  children,
  rootField,
  onSuccess,
  paramValidator,
}) => {
  const [queryVars, setQueryVars] = useState(variables || {});
  const [oldVars, setOldVars] = useState(variables || {});
  const {data, fetchData, isLoading} = useGraphqlQuery(
    initialState,
    QUERY,
    rootField
  );

  const fetch = async () => {
    if (
      queryVars &&
      (paramValidator ? paramValidator!(oldVars, queryVars) : true)
    ) {
      setOldVars(queryVars);
      await fetchData(queryVars);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryVars]);

  useEffect(() => {
    if (onSuccess) {
      onSuccess(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <LoaderWithBackdrop isLoading={!!isLoading} />
      {children({data, isLoading, fetch, setQueryVars})}
    </>
  );
};
export default GqlQueryController;
